import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IItem } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ItemService extends BaseService<IItem> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'item');
  }
}

export { IItem } from '../shared/api';
